.matchProfileInfo {
  max-width: 400px;
  display: flex;
  flex-direction: column;
  gap: var(--spacingMd);
}

.matchProfileHeader {
  display: flex;
  gap: var(--spacingMd);
  align-items: center;
}

.profileName {
  overflow-wrap: anywhere;
}

.addedBy {
  display: flex;
  column-gap: var(--spacingMd);
}

.skills {
  margin-top: var(--spacingMd);
}

.customValues {
  overflow-wrap: anywhere;
}
